// extracted by mini-css-extract-plugin
export default {"container":"TotalComponent_container__bxISi","error":"TotalComponent_error__2Uakj"};